import React from 'react';

const PricingSection = () => {
  return (
    <section className="pricing-section" id="enroll">
      <div className="pricing-inner">
        <p className="section-eyebrow" style={{ marginBottom: '14px' }}>Enroll Today</p>
        <h2 className="section-title" style={{ marginBottom: '40px' }}>Start with the Masterclass.<br /><em>Build the full platform.</em></h2>
        <div className="pricing-card">
          <div className="pricing-left">
            <p className="pricing-tag">Module 1 · Live 16 April 2025</p>
            <h3 className="pricing-name">The M&A Masterclass</h3>
            <p className="pricing-sub">The knowledge foundation — three hours that change how you see your exit.</p>
            <ul className="inc-list">
              <li>Full 3-hour masterclass — 4 sections, 130+ slides, slide-by-slide narration</li>
              <li>M&A Fundamentals: readiness, buyer landscape, data room, QoE</li>
              <li>The 10 Value Maximizers — complete assessment framework</li>
              <li>M&A Sale Process, deal structure, earn-outs &amp; closing mechanics</li>
              <li>Downloadable frameworks, checklists &amp; the Magic Number calculator</li>
              <li>15-point LOI checklist &amp; earn-out negotiation guide</li>
              <li>Lifetime access — revisit any section at any time</li>
              <li>Ready for Modules 2 &amp; 3 when they launch on 18 June 2026</li>
            </ul>
          </div>
          <div className="pricing-right">
            <p className="price-label">Masterclass Investment</p>
            <p className="price-amount"><span>₹</span>24,999</p>
            <p className="price-note">One-time · Lifetime access</p>
            <a href="https://learning.digilantsolution.com/" className="btn-enroll">Enroll Now — 16 April 2025</a>
            {/* <a href="mailto:sunilnikhar@digilantsolution.com?subject=ValueARC Masterclass Enrollment" className="btn-enroll">Enroll Now — 16 April 2025</a> */}
            <p className="guarantee-text">Questions? Write to Sunil directly.<br />He answers personally.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
